import {z} from "zod/v4-mini"

export type Axis = "X" | "Y" | "Z"
export const axisSchema = z.enum(["X", "Y", "Z"])

export type DirectionType = "UV_MAP" | "RADIAL"
export const directionTypeSchema = z.enum(["UV_MAP", "RADIAL"])
